const connectionTypes = {
    WIFI: 'wifi',
    CELLULAR: 'cellular',
    BLE: 'BLE',
    SIDEWALK: 'sidewalk',
};

export default connectionTypes;
